import React from 'react';

function Affiliations() {
  return (
    <section className="affiliations-section" id="affiliations">
      <div className="section-title">
        <h2>Affiliations & Approvals</h2>
      </div>
      <div className="affiliations-grid">
        <div className="affiliation-card">
          <div className="affiliation-icon">🏛️</div>
          <h4>Kurukshetra University</h4>
          <p>Affiliated to Kurukshetra University for B.Ed program with full recognition.</p>
        </div>
        <div className="affiliation-card">
          <div className="affiliation-icon">✅</div>
          <h4>NCTE Approved</h4>
          <p>Approved by National Council for Teacher Education since 2015.</p>
          <a href="/ncte-affiliation.pdf" target="_blank" rel="noopener noreferrer" className="affiliation-btn">
            View Certificate
          </a>
        </div>
        <div className="affiliation-card">
          <div className="affiliation-icon">📋</div>
          <h4>Mahavir Shiksha Samiti</h4>
          <p>Working under the administration of Mahavir Shiksha Samiti, Karnal.</p>
        </div>
      </div>
    </section>
  );
}

export default Affiliations;
